var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#F09A0FFF",
        height: "20px",
        width: "20px",
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 473.506 473.506",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _vm._v(" "),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
      _vm._v(" "),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("path", {
          attrs: {
            d: "M436.174,74.686H37.331C16.708,74.686,0,91.403,0,112.027v249.454c0,20.622,16.708,37.339,37.331,37.339h398.843 c20.623,0,37.332-16.717,37.332-37.339V112.027C473.506,91.403,456.797,74.686,436.174,74.686z M257.407,250.379v29.246 c0,11.407-9.233,20.654-20.654,20.654c-11.407,0-20.655-9.247-20.655-20.654v-29.246c-8.354-6.288-13.81-16.185-13.81-27.436 c0-19.029,15.428-34.481,34.465-34.481c19.036,0,34.465,15.452,34.465,34.481C271.218,234.195,265.761,244.091,257.407,250.379z M167.545,256.328L58.987,358.797c-3.053,2.883-6.951,4.309-10.835,4.309c-4.192,0-8.37-1.657-11.484-4.947 c-5.98-6.344-5.687-16.332,0.648-22.311l107.232-101.222L37.316,133.406c-6.335-5.981-6.629-15.97-0.648-22.312 c5.996-6.328,15.97-6.628,22.319-0.639L178.658,223.42c0.108,13.795,4.994,26.758,13.765,37.024v19.182 c0,0.078,0.016,0.14,0.016,0.217L167.545,256.328z M436.204,335.847c6.336,5.979,6.628,15.968,0.647,22.311 c-3.113,3.29-7.291,4.947-11.482,4.947c-3.885,0-7.784-1.426-10.836-4.309l-108.559-102.47l-24.908,23.515 c0-0.069,0.016-0.139,0.016-0.217v-19.182c4.825-5.633,8.354-12.131,10.696-19.082c1.912-5.702,3.022-11.715,3.068-17.926 c0-0.008,0-0.008,0-0.008l119.686-112.973c6.35-5.988,16.323-5.688,22.318,0.639c5.98,6.342,5.688,16.331-0.647,22.312 l-107.231,101.22L436.204,335.847z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }